import React from "react";
import ComingSoon from "../components/common/ComingSoon";

function CorporateTraining({ theme }) {
  return <ComingSoon theme={theme} />;
}

export default CorporateTraining;
